import { useState, useEffect } from "react";
import Autosuggest from "react-autosuggest";

export default function Autocomplete({ onSelect }) {
  const [listaSN, setListaSN] = useState([]);
  const [sugerencias, setSugerencias] = useState([]);
  const [value, setValue] = useState("");

  // ==========================================
  // Cargar SN desde Google Script
  // ==========================================
  useEffect(() => {
    async function cargar() {
      try {
        const resp = await fetch(
          "https://script.google.com/macros/s/AKfycbylwmhTsVvCV4aN1CC-HW7Ms9VAfbHQB-pMxSMp08vp-aPwDuCSFKh09tvkjGwoS3Uy/exec"
        );
        const data = await resp.json();
        setListaSN(Object.keys(data));  
      } catch (e) {
        console.error("Error cargando lista:", e);
      }
    }
    cargar();
  }, []);

  // ==========================================
  // Filtrar SN — mínimo 4 caracteres
  // ==========================================
  const filtrar = (txt) => {
    const t = txt.trim().toLowerCase();
    if (t.length < 4) return [];
    return listaSN.filter((sn) => sn.toLowerCase().includes(t));
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSugerencias(filtrar(value));
  };

  const onSuggestionsClearRequested = () => {
    setSugerencias([]);
  };

  const getSuggestionValue = (s) => {
    onSelect?.(s);
    return s;
  };

  const renderSuggestion = (s) => (
    <div className="px-3 py-2 bg-white border-bottom">{s}</div>
  );

  const onChange = (e, { newValue }) => {
    setValue(newValue.trim());
    if (newValue.length >= 4) onSelect?.(newValue);
  };

  // ==========================================
  // Bootstrap input
  // ==========================================
  const inputProps = {
    placeholder: "Ingrese (S/N)",
    value,
    onChange,
    className: "form-control form-control-lg",
    id: "SNGenerico",
    autoComplete: "off",
  };

  // ==========================================
  // Render final
  // ==========================================
  return (
    <div className="mb-3">
      <label className="form-label fw-semibold">Número de Serie</label>
      <Autosuggest
        suggestions={sugerencias}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        theme={{
          container: "position-relative",
          suggestionsContainer:
            "position-absolute w-100 bg-white border rounded shadow z-3 mt-1",
          suggestionsList: "list-unstyled m-0 p-0",
          suggestionHighlighted: "bg-light",
        }}
      />
    </div>
  );
}
